import { render, staticRenderFns } from "./AncillaryMemberCard.vue?vue&type=template&id=1050ae1f&scoped=true"
import script from "./AncillaryMemberCard.vue?vue&type=script&lang=js"
export * from "./AncillaryMemberCard.vue?vue&type=script&lang=js"
import style0 from "./AncillaryMemberCard.vue?vue&type=style&index=0&id=1050ae1f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1050ae1f",
  null
  
)

export default component.exports